import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
  expandRangeValues,
  getRangeOrder,
} from 'src/app/shared/constants/firmographic-ranges';
import { GlobalSearchResultTypeEnum } from 'src/portal/search-api/models/global-search-result-type-enum';
import { SuggestService } from 'src/portal/search-api/services/suggest.service';

@Component({
  selector: 'search-filter-checkbox-list',
  templateUrl: './search-filter-checkbox-list.component.html',
  styleUrls: ['./search-filter-checkbox-list.component.scss'],
})
export class SearchFilterCheckboxListComponent implements OnInit, OnChanges {
  @Input() searchType: GlobalSearchResultTypeEnum = GlobalSearchResultTypeEnum.COMPANY;
  @Input() label: string;
  @Input() searchField: string;
  @Input() items: any[] = [];
  @Input() iconName: string;
  @Input() expanded: boolean = false;
  @Output() itemsChange = new EventEmitter<any[]>();

  loading: boolean = true;
  elements: any[] = [];
  dataLoaded: boolean = false;

  constructor(private suggestService: SuggestService) {}

  ngOnInit(): void {
    this.loadSuggestions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.items && this.dataLoaded) {
      this.syncRangeItems();
      this.updateSelection();
    }
  }

  private loadSuggestions(): void {
    this.suggestService
      .suggest({
        entity: this.searchType,
        field: this.searchField,
        search: '',
      })
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((res) => {
        this.elements = this.buildElements(res);
        this.dataLoaded = true;
        this.syncRangeItems();
        this.updateSelection();
      }, error => {
        console.error('Ошибка при загрузке данных:', error);
        this.elements = [];
        this.dataLoaded = true;
      });
  }

  private buildElements(elements: any[]): any[] {
    const order = getRangeOrder(this.searchField);
    if (!order) {
      return elements;
    }

    return order.map((name) => {
      const existingItem = elements.find((item) => item.name === name);

      return {
        ...existingItem,
        name,
        checked: false,
      };
    });
  }

  private syncRangeItems(): void {
    const normalizedItems = expandRangeValues(this.searchField, this.items);

    if (
      normalizedItems.length === this.items.length &&
      normalizedItems.every((value, index) => value === this.items[index])
    ) {
      return;
    }

    this.items.splice(0, this.items.length, ...normalizedItems);
  }

  private updateSelection(): void {
    if (this.elements.length === 0) {
      console.warn('Массив elements пуст, пропускаем обновление выбора.');
      return;
    }

    this.elements.forEach(item => {
      item.checked = this.items.includes(item.name);
    });
  }

  onSelectionChanged(itemName: string, event: any): void {
    if (event.checked) {
      this.items.push(itemName);
    } else {
      const index = this.items.indexOf(itemName);
      if (index >= 0) {
        this.items.splice(index, 1);
      }
    }
    this.itemsChange.emit(this.items);
  }
}
